import type { Nullable } from '@enmon/commons';
import { RoleName } from '@enmon/commons/lib/tools';
import { useRecoilValue } from 'recoil';
import { sessionState } from 'store';
import type { UserInfo } from 'types/userInfo';

export const useUserInfo = (): UserInfo => useRecoilValue(sessionState).userInfo;

export const useIsMagicRole = (): boolean => {
  const userInfo: Nullable<UserInfo> = useUserInfo();
  return !!userInfo?.role && userInfo.role.name === RoleName.Magic;
};

export const useIsResellerRole = (): boolean => {
  const userInfo: Nullable<UserInfo> = useUserInfo();
  return !!userInfo?.role && userInfo.role.name === RoleName.Reseller;
};
